import { i18n } from '@fs/zion-locale'

export default {
  addAnotherDatePlaceHolder: () => i18n.t('editableCoverageDate.addAnotherDatePlaceHolder', 'Add another date'),
  addDatePlaceHolder: () => i18n.t('editableCoverageDate.addDatePlaceHolder', 'Add a date'),
  datePlaceholder: () => i18n.t('editableCoverageDate.datePlaceholder', 'Date'),
  selectDateLabel: (date) => i18n.t('editableCoverageDate.selectDateLabel', 'Select date {date}', { date }),
  approximateMessage: () =>
    i18n.t(
      'editableCoverage.approximateMessage',
      'This field does not currently support approximate dates. Please use an exact date range.'
    ),
  standardDateErrorMessage: () =>
    i18n.t('editableCoverage.standardDateErrorMessage', 'You must select a standardized date.'),
  dateRangeEntirelyOutside: () =>
    i18n.t(
      'editableCoverageDate.dateRangeEntirelyOutside',
      'Date range is entirely outside the standardized place date range. You may have selected the wrong place.'
    ),
  dateRangePartiallyOutside: () =>
    i18n.t(
      'editableCoverageDate.dateRangePartiallyOutside',
      'Date range extends outside the standardized place date range.'
    ),
}
